import getContext from '../utilities/get-context';

export default function () {
  if (typeof window === 'undefined') {
    return {};
  }

  const userData = getContext().__MA__.user;
  if (typeof userData.id === 'undefined') {
    return {};
  }

  let userStatus;
  if (!userData || !userData.id) {
    userStatus = 'guest';
  } else {
    userStatus = userData.plan === 'free' ? 'Free trial' : 'subscriber';
  }

  const {
    id,
    first_name,
    last_name,
    email,
    plan,
    state,
    tos_accepted,
    first_subscribed_at,
    created_at,
    is_seller_with_approved_submission,
  } = userData;
  const fullName = `${first_name || ''} ${last_name || ''}`.trimEnd() || '—';

  return {
    user_id: id.toString(),
    created_at,
    first_subscribed_at,
    accept_cookie: !!tos_accepted,
    user_plan: plan,
    $first_name: first_name || '',
    $last_name: last_name || '',
    $name: fullName,
    $email: email,
    State: state,
    userStatus,
    seller: is_seller_with_approved_submission,
  };
}
